import { Box, Checkbox, darken, FormControlLabel, Stack } from "@mui/material";
import { useTranslation } from "react-i18next";

import { VISIT_STATUS_TO_COLOR_MAP } from "~/config/statusColors";

import { FILTER_VISIT_RISK_STATUS_ALL } from "../../screens/PlannerV2Screen/PlannerV2AreasScreen/hooks/usePlannerV2AreaFilters";

export function VisitStatusFilter({
    filterStatuses,
    onChange,
}: {
    filterStatuses: string[];
    onChange: (status: string, checked: boolean) => void;
}) {
    const { t } = useTranslation("plannerV2");
    return (
        <Stack marginBlockEnd={0} sx={theme => ({ border: `1px solid ${theme.palette.divider}` })}>
            {FILTER_VISIT_RISK_STATUS_ALL.map(status => (
                <Box key={status} sx={{ borderLeft: `8px solid ${VISIT_STATUS_TO_COLOR_MAP[status]}` }}>
                    <FormControlLabel
                        label={t(`plannerStatus.${status}`)}
                        key={status}
                        sx={theme => ({
                            margin: 0,
                            display: "block",
                            borderBottom: `1px solid ${theme.palette.divider}`,
                            "&:hover": {
                                backgroundColor: darken(theme.palette.background.paper, 0.03),
                            },
                        })}
                        control={<Checkbox color="default" checked={filterStatuses.includes(status)} />}
                        onChange={(_event, checked) => onChange(status, checked)}
                    />
                </Box>
            ))}
        </Stack>
    );
}
